<template>
    <BaseSpinner v-if="deadlinesPending || subsidiesPending" />
    <ul
        v-else
        class="deadlines-overview"
    >
        <template v-for="(deadline, key) in groupedByDeadline">
            <DeadlineCard
                v-for="(subsidy, index) in deadline?.subsidies"
                :key="`${key}-${index}`"
                :deadline="{
                    title: subsidy?.title,
                    deadline: deadline?.deadline,
                    uri: subsidy?.uri,
                    phase: deadline?.phase
                }"
            />
        </template>
    </ul>
</template>

<script setup>
import { formatISO } from 'date-fns';
import getDeadlines from '~/graphql/queries/getDeadlines.graphql';
import getSubsidiesWithDeadlines from '~/graphql/queries/getSubsidiesWithDeadlines.graphql';

const { variables: defaultVariables }  = useCraftGraphql();

const deadlineVariables = computed(() => {
    const now = formatISO(Date.now(), { representation: 'date' });

    return {
        ...defaultVariables,
        uri: null,
        now: [`>= ${now}`]
    };
});

const { data: deadlinesData, pending: deadlinesPending } = await useLazyAsyncQuery({
    query: getDeadlines,
    variables: deadlineVariables
});

const deadlines = computed(() => deadlinesData.value?.entries ?? []);

const subsidiesVariables = computed(() => {
    return {
        ...defaultVariables,
        uri: null,
        deadlines: deadlines.value?.map(({ id }) => id) ?? []
    };
});

const { data: subsidiesData, pending: subsidiesPending } = await useLazyAsyncQuery({
    query: getSubsidiesWithDeadlines,
    variables: subsidiesVariables
});

const subsidies = computed(() => subsidiesData.value?.entries ?? []);

const groupedByDeadline = computed(() => {
    return deadlines.value?.map(({ id, deadline, phase }) => {
        return {
            id,
            deadline,
            phase,
            subsidies: subsidies.value?.filter(({ periodsRelation }) => {
                return periodsRelation
                    .map(({ id: periodId }) => periodId)
                    .includes(id);
            })
        };
    });
});
</script>

<style lang="less" src="./DeadlinesOverview.less" />
